import { render, staticRenderFns } from "./ProductsListViewMS.vue?vue&type=template&id=69a7d8ab&scoped=true"
import script from "./ProductsListViewMS.vue?vue&type=script&lang=js"
export * from "./ProductsListViewMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a7d8ab",
  null
  
)

export default component.exports